import { translate as t } from 'react-i18next';
import { ModuleRegistry } from 'react-module-container';

export const withTranslation = (Class) => t()(Class);
export const withTranslationPending = (Class) => t(null, { wait: true })(Class);

export const openImagesGallery = ({ translation, onSelectImageSuccess }) => {
  const category = ModuleRegistry.invoke('mediaManager.categories', {}).IMAGE;
  const onSuccess = ({ items }) => {
    const [{ uri, width, height }] = items;
    return onSelectImageSuccess({ uri, width, height });
  };

  ModuleRegistry.invoke('mediaManager.open', category, 'contacts', {
    onSuccess,
    multiSelect: false,
    translation,
  });
};
